import { z } from 'zod';

export const loginSchema = z.object({
  username: z.string().min(1, 'username_required').max(120, 'username_too_long'),
  password: z.string().min(1, 'password_required').max(255, 'password_too_long'),
  /** Optional on the first step; required when backend asks for OTP. */
  otp: z
    .string()
    .regex(/^\d{6}$/, 'otp_invalid_format')
    .optional(),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
